"use client";

import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBlog } from "@fortawesome/free-solid-svg-icons";
import BlogArticleCard from "../../components/BlogArticleCardCosmic";
import { useAllArticles } from "../../lib/hooks/allArticlesCosmic";
import Breadcrumbs from "../../components/Breadcrumbs.jsx";

export default function BlogClient() {
  const {
    filteredArticles,
    categories,
    handleCategoryChange,
    selectedCategory,
  } = useAllArticles();

  return (
    <div className="flex">
      <div className="">
        <main id="main">
          <div className="min-h-full">
            <div className=" mx-10 px-4 my-10">
              <Breadcrumbs currentPage="Blog" />
              <h1 className="text-4xl my-5 flex items-center">
                <FontAwesomeIcon
                  icon={faBlog}
                  className="w-12 h-12 p-2 mr-2 ml-0"
                />
                Blog
              </h1>
              <p className="mb-5">
                Vous trouverez sur cette page des astuces, inspirations et
                solutions concernant le développement web et le graphisme.
              </p>
              <div className="mb-6 flex items-center justify-start">
                <div className="inline-flex border border-gray-300 rounded">
                  <button
                    type="button"
                    className={`inline-block rounded-s px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal transition duration-150 ease-in-out border-r border-gray-300 ${
                      selectedCategory === "all"
                        ? "bg-bleuciel text-white hover:bg-blue-700"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
                    onClick={() => handleCategoryChange("all")}>
                    Tous les thèmes
                  </button>
                  {categories.map((category, index) => (
                    <button
                      key={category}
                      type="button"
                      className={`inline-block px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal transition duration-150 ease-in-out ${
                        index === categories.length - 1
                          ? "rounded-e"
                          : "border-r border-gray-300"
                      } ${
                        selectedCategory === category
                          ? "bg-bleuciel text-white hover:bg-blue-700"
                          : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                      }`}
                      onClick={() => handleCategoryChange(category)}>
                      {category}
                    </button>
                  ))}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {Array.isArray(filteredArticles) ? (
                  filteredArticles.map((article) => (
                    <BlogArticleCard key={article.id} article={article} />
                  ))
                ) : (
                  <p className="text-error">Pas d&apos;articles disponibles</p>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
